import { useRouteMatcher } from '@/utils/url';

import Constants from '@/constants';

import { usePlansCertificatesData } from './usePlansCertificatesData';
import { useReportsCertificatesData } from './useReportsCertificatesData';

export type { CertificateData } from './certificates.types';
export type { CertificatesDataOptions as UsePrintCertificatesDataOptions } from './certificates.types';
export type { CertificatesDataResult as UsePrintCertificatesDataResult } from './certificates.types';

interface UsePrintCertificatesDataOptions {
  teamMemberId?: string | null;
  planId?: string | null;
  enabled?: boolean;
}

/**
 * Route-aware orchestrator for certificate data.
 *
 * Delegates to `usePlansCertificatesData` on `/plans` routes and
 * `useReportsCertificatesData` on `/reports` routes. Both sub-hooks
 * are always called (rules of hooks) but self-disable via `enabled`
 * when on the wrong route.
 */
export const usePrintCertificatesData = ({
  teamMemberId,
  planId,
  enabled = true,
}: UsePrintCertificatesDataOptions) => {
  const routeMatches = useRouteMatcher();
  const isPlansRoute = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.TrainingPath,
  );
  const isReportsRoute = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.ReportsPath,
  );

  const plans = usePlansCertificatesData({
    teamMemberId,
    planId,
    enabled: enabled && isPlansRoute,
  });

  const reports = useReportsCertificatesData({
    teamMemberId,
    planId,
    enabled: enabled && isReportsRoute,
  });

  return isPlansRoute ? plans : reports;
};
